import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { RENDEZ_VOUS } from "../../Utils/constant";
import { store } from "../../services/service";
import { useStoreCreneau } from "../../store/Paramettre/creneauStore";
import { SubmitButton } from "../Widget/SubmitButton";
import { ValidateMessage } from "../Widget/ValidateMessage";

export const PriseRendezVousRaccordement = ({ numeroTicket }) => {
    const [dateStartRaccord, setStartDateRaccord] = useState(null);
    const [isSubmit, setIsSubmit] = useState(false)
    const navigate = useNavigate()

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const creneau = useStoreCreneau();
    const dateDispo = useStoreCreneau();
    useEffect(() => {
        dateDispo.dateDispo(numeroTicket);
    }, []);

    const submit = (data) => {
        setIsSubmit(true)
        const raccordRequest = {
            numeroTicket: numeroTicket,
            creneauId: data.creneauIdRaccord,
            typeRdv: "RACCORDEMENT",
            dateRdv: dateStartRaccord.toLocaleDateString().replace(/\//g, "-"),
        };
        store(RENDEZ_VOUS, 'application/json', raccordRequest).then((res) => {
            if (res.status === 200) {
                setIsSubmit(null)
                toast.success('Prise de rendez-vous éffectuée')
            }
        }).catch((err) => {
            setIsSubmit(false)
            toast.error(err?.response?.data?.donnee)
        })
    };
    return (
        <>
            {isSubmit !== null ?
                <form onSubmit={handleSubmit(submit)}>
                    <div className="">
                        <div className="w-full  mx-auto  mt-6">
                            <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                                <label className="form-control flex flex-col  gap-2  w-full">
                                    <label className="form-control  w-full">
                                        <div className="label -mb-1">
                                            <span className="label-text font-medium">
                                                Date du rendez-vous <span className="text-red-500">*</span>
                                            </span>
                                        </div>

                                        <div className="flex lg:flex-row md:flex-row xl:flex-row flex-col gap-2">
                                            <ReactDatePicker
                                                locale="fr"
                                                dateFormat="dd-MM-yyyy"
                                                selected={dateStartRaccord}
                                                includeDates={dateDispo?.dates}
                                                className="  px-2 flex items-center justify-center border-[1px] h-8 rounded-lg"
                                                onChange={(date) => {
                                                    setStartDateRaccord(date)
                                                    creneau.creneauDispo(date, numeroTicket);
                                                }}
                                                placeholderText="choisir une date"
                                            />
                                        </div>
                                    </label>
                                    <div className="flex flex-row gap-2">
                                        <label className="form-contro  w-full">
                                            <div className="label -mb-1">
                                                <span className="label-text font-medium">
                                                    Créneau horaire <span className="text-red-500">*</span>
                                                </span>
                                            </div>
                                            <select
                                                {...register("creneauIdRaccord", { required: true })}
                                                className="select select-bordered w-full h-10"
                                            >
                                                <option value={''} disabled selected>
                                                    Choisir un Créneau
                                                </option>
                                                {
                                                    creneau?.creneaux?.map((item) => (
                                                        <option value={item.id}>
                                                            {item.heureDebut} - {item.heureFin}
                                                        </option>
                                                    ))
                                                }
                                            </select>
                                        </label>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <SubmitButton isSubmit={isSubmit} label={'Enregistrer'} />
                    </div>

                </form>
                : <ValidateMessage texte={'Prise de rendez-vous de raccordement effectuée'} />
            }
            <div className="w-full mt-4">
                <hr />
                <div
                    className="flex mt-4"
                    sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                >

                    <Box sx={{ flex: "1 1 auto" }} />
                    <span
                        disabled={isSubmit !== null ? true : false}
                        className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
                        onClick={() => {
                            window.history.back()
                            localStorage.removeItem('numeroTicket')
                        }}
                    >
                        Terminer
                    </span>
                </div>
            </div>
        </>
    );
};
